export const SOURCES = {
  CMS_APPLICATION: 'cms_application',
  PREVIEW_APPLICATION: 'preview_application'
};

export const ACTIONS = {
  PREVIEW_LOADED: 'preview_loaded'
};
